export const AddTextIcon = () => (
    <svg
        width={19}
        height={14}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="stroke-irBlue-200 dark:stroke-white group-hover:stroke-white"
    >
        <path
            d="M1.5 3V1h12v2M7.5 13h-2m2-12v12V1Zm0 12h2-2ZM11.5 8.5V7h6v1.5M14.5 13H16m-1.5-6v6-6Zm0 6H13h1.5Z"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
